import { WidgetType } from "components/dashboard/utils/widgetConfig";
import { ComponentType } from "react";

type DashboardTagOptionLabel = {
    color: string;
    empty: boolean;
    circular: boolean;
};

export type DashboardTagOptions = {
    key: string;
    text: string;
    value: string;
    label: DashboardTagOptionLabel;
};

// --- Types ---
export type WidgetItem = {
    id: number;
    name: string;
    description: string;
    ImagePreview: string | ComponentType<React.SVGProps<SVGSVGElement>>;
    type: WidgetTypeList;
    widgetType: WidgetType;
};

// Export WidgetCategory type for test usage
export type WidgetCategory = {
    id: WidgetSource | WidgetTypeList;
    label: string;
    Icon: React.ComponentType<any>;
    widgets: WidgetItem[];
};

export enum WidgetSource {
    Sensor = "sensor",
    Actuator = "actuator",
    Gateway = "gateway",
    Meter = "meter",
    Event = "event",
    Subscription = "subscription",
    LDSU = "ldsu",
    ExternalData = "externalData",
    PSL = "psl",
}

export enum WidgetBESourceList {
    MULTIPLE_SENSORS = "MULTIPLE_SENSORS",
    SINGLE_SENSOR = "SINGLE_SENSOR",
    SINGLE_ACTUATOR = "SINGLE_ACTUATOR",
    SINGLE_GATEWAY = "SINGLE_GATEWAY",
    MULTIPLE_GATEWAYS = "MULTIPLE_GATEWAYS",
    STORAGE = "STORAGE",
    EVENT = "EVENT",
    NOTIFIER = "NOTIFIER",
}

export enum WidgetTypeList {
    Card = "card",
    Chart = "chart",
    Dial = "dial",
    Image = "image",
    Calendar = "calendar",
    Table = "table",
    Maps = "maps",
    ImageLayout = "imageLayout",
}

export enum WidgetChartTypeEnum {
    TIME,
    SINGLE,
    MULTIPLE,
    STACKED,
    COMBINED,
    COUNT_ALERT_TRIGGER,
    NOTIFIER_COUNT,
    COUNT_ALERT,
    ENERGY_CONSUMPTION,
    WATER_CONSUMPTION,
    TEMPERATURE_CARD,
    ANY_CARD,
    IAQ_CARD,
    HUMIDITY_CARD,
    AMBIENT_LIGHT_CARD,
    MOTION_CARD,
    MULTIPLE_LINES_CARD,
    OVERVIEW,
    STATUS,
    HISTORY,
    HEATMAP,
    STORAGE,
    STATISTICS,
    GAUGE,
    GAUGE_COLOURS,
    MULTIPLE_LINES,
    SINGLE_LINE,
    BAR,
    ROOM_TIMELINE,
    ZONE_TIMELINE,
    GROUP_TIMELINE,
    SENSORS_AND_ACTUATORS,
    MULTIPLE_LINES_CARD_TYPE2,
    MULTIPLE_LINES_CARD_TYPE3,
    TOKEN_DONUT,
    TOKEN_STACKED,
}

export type WidgetSubmitData = {
    widgetType?: WidgetTypeList;
    widgetSource: WidgetSource;
    widgetTemplate: WidgetItem;
};

export type WidgetSourceKey = WidgetSource;
export type WidgetTypeKey = `${WidgetTypeList}`;
